import Vue from "vue";

import Orejime from "orejime/dist/orejime";
import { i18n } from "vue-lang-router";

export default class Rgpd extends Vue {

  public static rgpdInit: any;

  static initRgpd = () => {

    const orejimeConfig = {
      appElement: "#app",
      cookieName: "AFS_RGPD_OREJIME",
      cookieExpiresAfterDays: 365,
      privacyPolicy: "/gestion-des-cookies",
      lang: i18n.locale || "fr",
      default: true,
      mustConsent: false,
      mustNotice: true,
      implicitConsent: false,
      poweredBy: i18n.t("cookie.list.link"),
      translations: {
        fr: {
          poweredBy: i18n.t("cookie.list.title"),
          consentNotice: {
            description: i18n.t("cookie.notice.description"),
            learnMore: i18n.t("cookie.learnMore"),
          },
          consentModal: {
            title: i18n.t("cookie.noticeModal.title"),
            description: i18n.t("cookie.noticeModal.description"),
            privacyPolicy: {
              name: i18n.t("cookie.pageTitle"),
              text: i18n.t("cookie.privacy"),
            },
          },
          internalTracker: {
            title: i18n.t("cookie.internalTracker.title"),
            description: i18n.t("cookie.internalTracker.description"),
          },
          app: { optOut: { title: "" }, required: { title: "" }, purposes: "Utilisations", purpose: "Utilisation" },
        },
        en: {
          poweredBy: i18n.t("cookie.list.title"),
          consentNotice: {
            description: i18n.t("cookie.notice.description"),
            learnMore: i18n.t("cookie.learnMore"),

          },
          acceptAll: "Accept all cookies",
          declineAll: "Decline all cookies",
          consentModal: {
            title: i18n.t("cookie.noticeModal.title"),
            description: i18n.t("cookie.noticeModal.description"),
            privacyPolicy: {
              name: i18n.t("cookie.pageTitle"),
              text: i18n.t("cookie.privacy"),
            },
          },
          internalTracker: {
            title: i18n.t("cookie.internalTracker.title"),
            description: i18n.t("cookie.internalTracker.description"),
          },

          app: {
            optOut: { title: "" }, required: { title: "" }, purposes: {}, purpose: "Utilisation",
          },
        },
      },
      apps: [{
        name: "internal-tracker",
        title: i18n.t("cookie.internalTracker.title"),
        description: i18n.t("cookie.internalTracker.description"),
        cookies: [
          "_ga",
          "_gat",
          "_gid",
          "__utma",
          "__utmb",
          "__utmc",
          "__utmt",
          "__utmz",
          "_ga_MQM752QLEQ",
          "_gat_gtag_MQM752QLEQ",
          "_gat_MQM752QLEQ",
          "_gat_gtag_NLCWKJR",
          "_gat_NLCWKJR"],
        default: true,
        required: true,
      }, {
        name: "google-analytics",
        title: i18n.t("cookie.googleAnalytic.title"),
        description: i18n.t("cookie.googleAnalytic.description"),
        required: false,
        default: false,
        cookies: [],
        callback: function (e) {
          /*
           const i = "disable-google";
           window[i] = !e;
           */

          /* window.dataLayer = window.dataLayer || [];
           if (e) {
             window.dataLayer.push("consent", "update", {
               "ad_storage": "granted",
             });
           } else {
             window.dataLayer.push("consent", "update", {
               "ad_storage": "denied",
             });
           }*/
        },
      },
        {
          name: "facebook",
          title: i18n.t("cookie.social.title"),
          description: i18n.t("cookie.social.description"),
          cookies: ["_fbp", "_gcl_au", "NID", "1P_JAR", "ANID", "DV"],
          required: false,
          default: false,

          callback: function (e) {
            const i = "disable-facebook";
            window[i] = !e;

          },
        },
      ],
      /* categories: [
         {
           name: "default",
           title: "Example category",
           apps: ["internal-tracker"],
         },
         {
           name: "third-party",
           title: "Third-party applications",
           apps: ["google-analytics", "facebook"],
         },
       ],*/
    };

    Rgpd.rgpdInit = Orejime.init(orejimeConfig);

    const cookieShowModal = document.getElementById("setCookie");

    if (cookieShowModal) {
      cookieShowModal.onclick = function (e) {
        e.preventDefault();
        //your handler here
        Rgpd.rgpdInit.show();
      };
    }
  };
}